// inv/src/components/ui/input.jsx
import { cn } from "../../lib/utils";

const Input = React.forwardRef(
  (
    {
      multi = true,
      value,
      onChange,
      selectedValues = [],
      onRemoveValue,
      onAddValue,
      className,
      type = "text",
      placeholder = "",
      ...props
    },
    ref
  ) => {
    if (!multi) {
      return (
        <div className={cn("flex items-center h-8 px-2 py-1 rounded-md border border-stone-300 bg-transparent shadow-sm transition-colors focus-within:ring-1 focus-within:ring-stone-200", className)}>
          <input
            ref={ref}
            type={type}
            className="flex-1 bg-transparent outline-none text-sm placeholder:text-muted-foreground"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            style={{
              minWidth: "150px",
              flexGrow: 1,
              height: "1.6rem",
            }}
            {...props}
          />
        </div>
      );
    }    

    const [currentInput, setCurrentInput] = React.useState("");
    const handleKeyDown = (event) => {
      if (event.key === "Enter" && currentInput.trim() !== "") {
        onAddValue?.(currentInput.trim());
        setCurrentInput("");
      }
    };

    const handleBlur = () => {
      if (currentInput.trim() !== "") {
        onAddValue?.(currentInput.trim());
        setCurrentInput("");
      }
    };

    return (
      <div
        className={cn(
          "flex flex-wrap items-center gap-2 px-2 py-1 rounded-md border border-stone-300 bg-transparent shadow-sm transition-colors focus-within:ring-1 focus-within:ring-stone-200",
          className
        )}
        style={{ minHeight: "1.6rem" }}
      >
        {selectedValues.map((val, index) => (
          <div
            key={index}
            className="flex items-center px-2 py-1 bg-stone-700 text-white  rounded-md text-sm"
            style={{ maxHeight: "1.6rem" }}
          >
            <span className="mr-1">{val}</span>
            <button
              type="button"
              onClick={() => onRemoveValue?.(val)}
              className="cursor-pointer text-white  hover:text-gray-300"
            >
              &times;
            </button>
          </div>
        ))}

        {selectedValues.length === 0 && (
          <input
            ref={ref}
            type={type}
            className="flex-1 bg-transparent outline-none text-sm placeholder:text-muted-foreground"
            value={currentInput}
            onChange={(e) => setCurrentInput(e.target.value)}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
            placeholder={placeholder}
            style={{
              minWidth: "150px",
              flexGrow: 1,
              height: "1.6rem",
            }}
            {...props}
          />
        )}
      </div>
    );
  }
);

Input.displayName = "Input";

export { Input };
